import React, { useEffect } from "react";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import { client_name, Theme } from "../../../../Helpers/request";
import BannerSlider from "./Components/Bannerslider";
import ShopByDiamondShape from "./Components/ShopByDiamondShape";
import ExploreCollection from "./Components/ExploreCollection";
import DesignDiamondRing from "./Components/DesignDiamondRing";
import ShopRingByStyle from "./Components/ShopRingByStyle";
import GemstoneGlamour from "./Components/GemstoneGlamour";
import CustomDesign from "./Components/CustomDesign";
import ConsultSpecialist from "./Components/ConsultSpecialist";
import Customer from "./Components/Customer";
import Insta from "./Components/insta";
import SignupTo from "./Components/SignupTo";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AsSeenOn from "./Components/AsSeenOn";
import Briteco from "./Components/Briteco";
import AboutUs from "./Components/AboutUs";
import { Modal, Image, Button } from 'react-bootstrap';
import HalloweenModal from "../../../../Assets/nokaoi-imges/HalloweenModal.png"
import ChristmasModal from "../../../../Assets/nokaoi-imges/popupnokaoi.jpg"
import "bootstrap/dist/css/bootstrap.min.css";
import StdBanner from "../../../../Assets/nokaoi-imges/stud/std-home.png"
import { Link } from "react-router-dom";
// import Snowfall from "react-snowfall";
// import "./Assets/showcase.css";


// if(Theme === 'showcase'){
// require(`./assets/css/showcase.css`);
// }
const 


ShowcaseHome = () => {
  const [show, setShow] = useState(false);
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const history = useHistory();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      // disable: 'mobile'
    });
    setShow(true);

  }, []);

  return (
    <>

      {/* <div className="al_snowfall" style={{ height: '100%', width: '100%', background: '#282c34', overflow: 'hidden' }}>
        <Snowfall  color="#fff"   snowflakeCount={250}  className="al_snowfall_canvas" />
      </div> */}
      <div className="LandingPageShocase ShowcaseThemHome" role='main'>
        <BannerSlider />
        <DesignDiamondRing />
        <ExploreCollection />

        <ShopByDiamondShape />
        <div className="std_home_div">
         <Link to="/stud-landing">  <img src={StdBanner} alt="stud-banner" className="img-fluid" /> </Link>
        </div>
        <ShopRingByStyle />

        {/* <GemstoneGlamour /> */}
        <CustomDesign />
        <AboutUs />
        {/* <ConsultSpecialist /> */}
        <Customer />
        <AsSeenOn />
        <Briteco />
        {/* <Insta /> */}
        <SignupTo />
         {/* <Modal
          show={show}
          onHide={() => setShow(false)}
          centered
          backdrop="static"
          keyboard={false}
          aria-labelledby="home-image-modal"
          contentClassName="bg-transparent border-0 shadow-none p-0"
        >
          <button
            onClick={() => setShow(false)}
            style={{
              position: "absolute",
              top: "10px",
              right: "26px",
              background: "transparent",
              border: "none",
              fontSize: "2.2rem",
              color: "#FFF",
              cursor: "pointer",
              zIndex: 1051,
            }}
            aria-label="Close"
          >
            ×
          </button>

          <Modal.Body className="text-center">
            <Image
              src={ChristmasModal}
              alt="Promotion"
              fluid
              rounded
            />
          </Modal.Body>
        </Modal>  */}
      </div>
    </>
  );
};

export default ShowcaseHome;
